import http from "./http";

// کیف پول
export const fetchMyWallet = () => http.get("/finance/my-wallet/");

// پورسانت‌ها
export const fetchMyCommissions = () => http.get("/finance/my-commissions/");

// پورسانت‌های ادمین
export const fetchAdminCommissions = (params) =>
  http.get("/finance/admin-commissions/", { params });

export const fetchAdminCommissionStore = (id) =>
  http.get(`/finance/admin-commissions/${id}/store-detail/`);

export const sendWithdrawRequest = (data) =>
  http.post("/finance/withdraw/request/", data);

export const fetchMyWithdrawalRequests = () =>
  http.get("/finance/withdraw/my-requests/");

export const fetchAdminWithdrawRequests = (params) =>
  http.get("/finance/admin/withdrawals/", { params });

export const updateWithdrawStatus = (id, status, admin_note = null) =>
  http.post(`/finance/admin/withdraw/update-status/${id}/`, {
    status,
    admin_note,
  });
